import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Mail } from 'lucide-react';
import { influencerData } from '../data/mock';

const CTASection = () => {
  return (
    <section className="bg-[#0B0B0B] py-24 relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#FF3B3B]/10 rounded-full blur-[150px]" />
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-[#FF3B3B]/10 border border-[#FF3B3B]/20 rounded-full px-4 py-2 mb-8">
          <span className="w-2 h-2 bg-[#FF3B3B] rounded-full animate-pulse" />
          <span className="text-[#FF3B3B] text-sm font-medium">Limited Availability for Q3 2025</span>
        </div>

        {/* Headline */}
        <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Ready to Reach <span className="text-[#FF3B3B]">1.4M+</span> Engaged Fitness Enthusiasts?
        </h2>

        <p className="text-[#9CA3AF] text-lg md:text-xl mb-10 max-w-2xl mx-auto">
          Let's create content that drives real results for your brand. Limited partnership spots available.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            className="bg-[#FF3B3B] hover:bg-[#E02F2F] text-white px-10 py-7 rounded-xl text-lg font-semibold transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-[#FF3B3B]/30 flex items-center gap-3 animate-pulse-subtle"
          >
            <Mail size={22} />
            Start a Partnership
            <ArrowRight size={20} />
          </Button>
          <Button
            variant="outline"
            className="border-white/20 bg-transparent text-white hover:bg-white/5 px-10 py-7 rounded-xl text-lg font-semibold transition-all duration-300 flex items-center gap-2"
          >
            Download Media Kit
          </Button>
        </div>

        {/* Contact Info */}
        <p className="text-[#9CA3AF] text-sm mt-10">
          Or email directly at <a href={`mailto:${influencerData.email}`} className="text-[#FF3B3B] hover:underline">{influencerData.email}</a>
        </p>
      </div>
    </section>
  );
};

export default CTASection;
